<template>
  <div class="result">
    <div class="container">

      <h1 class="uikit__h3">
        {{info.title}}
      </h1>

      <div class="result__wrapp">
        <div class="result__recall-companies">

          <div class="result__recall-companies_title" v-if="info.subtitle">
            {{info.subtitle}}
          </div>

          <div v-if="info.items" class="result__recall-companies_description">
            <ul>
              <li v-for="(item, i) in info.items" :key="i">
                <h4 class="uikit__h5">
                  <span>
                    {{info.itemPrefix}}
                  </span>
                  <span>
                    {{item.code}}.
                  </span>
                  <span>
                    {{item.label}}
                  </span>
                </h4>
                <p v-if="item.description">
                  {{item.description}}
                </p>
              </li>
            </ul>

          </div>

          <div class="result__recall-companies_proposal" v-if="info.proposal" v-html="info.proposal"></div>

          <div class="result_error-container error-container" v-if="info.text" v-html="info.text"></div>

          <div v-if="info.items > 10" class="result__loader" :class="{'is-animating': loading}">

            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 44.65 41.06">
              <defs>
                <clipPath id="a">
                  <path
                    fill="none"
                    d="M39.27 14.66a.89.89 0 0 0-1.24.22L35.84 18a15.49 15.49 0 1 0-1.92 10.4.89.89 0 0 0-1.53-.9 13.77 13.77 0 1 1 1.79-8.58l-4.12-2.43a.89.89 0 1 0-.9 1.53l5.56 3.28H34.87a.89.89 0 0 0 .3.06.87.87 0 0 0 .38-.09l.08-.06a.83.83 0 0 0 .22-.19l3.59-5.15a.89.89 0 0 0-.22-1.24"
                    clip-rule="evenodd"/>
                </clipPath>
              </defs>
              <g clip-path="url(#a)">
                <path
                  fill="#bcbec1"
                  d="M0 0h44.65v41.06H0z"/>
              </g>
            </svg>
          </div>
        </div>
      </div>


      <div class="form-search__desc" v-if="info.form">
        <a v-if="info.form.file" :href="info.form.file" class="form-search__link" target="_blank">
          {{ info.form.message }}
        </a>
        <p v-else>{{ info.form.message }}</p>
      </div>

      <div class="result__wrapp">
        <BaseBtn @click.native="openForm">{{info.button}}</BaseBtn>

        <WhiteBtn class="repeat-btn" v-if="info.buttonrepeat" @click.native="$emit('customEvent', 'enter_vin')">
          {{info.buttonrepeat}}
        </WhiteBtn>
      </div>

      <div v-if="info.items > 10" class="result__wrapp">
        <BaseBtn>
          {{messages.button}}
        </BaseBtn>
      </div>
    </div>
  </div>
</template>

<script>
  import BaseBtn from "@/components/base/BaseBtn";
  import WhiteBtn from "@/components/base/WhiteBtn";

  export default {
    name: "result",
    components: {
      BaseBtn,
      WhiteBtn
    },
    props: {
      messages: {
        type: Object,
        required: true
      },
      info: {
        type: Object
      },
      item: {
        type: Object
      },
      itemPrefix: {
        type: String
      }
    },
    data() {
      return {
        loading: true
      };
    },
    methods: {
      // resEvnt() {
      //   dataLayer.push({'event': 'checkvin'})
      // },
      openForm() {
        this.$emit("formOpen", "serviceRequest");
        // this.$emit("addInfoItems", this.info.items);
        this.$emit("addInfoItems", this.info);
        // this.$emit("addHint", this.info.hint);
        // this.$emit("addInfoItems", this.info.items);
        window.dataLayer.push({event: "checkvin"});
      }
    }
  };
</script>
<style lang="sass">
  @import '../assets/sass/partials/_sass-components.sass'

  @keyframes rotation
    to
      transform: rotate(1turn)

  .vin-button + .vin-button, .vin-button + .white-button
    margin-left: 20px
    @media only screen and (max-width: 767px)
      margin-top: 20px
      margin-left: 0
    @media only screen and (max-width:767px) and (orientation:landscape)
      margin-top: 0px
      margin-left: 20px

  .result
    // padding: 67px 0
    padding: 0
    &_error-container
      p 
        font-family: $text-font-book

    &__loader
      text-align: center
      margin-bottom: 40px
      +res('mob')
        margin-bottom: 30px
      &.is-animating
        > svg
          animation: rotation 1s linear infinite

    &__recall-companies
      text-align: left
      &_title
        font-family: $text-font-book
        font-size: 16px
        line-height: 1.37
        color: $black
        padding-top: 20px
        +res('mob')
          font-size: 15px
      &_description
        ul
          border-top: 1px solid #e4e4e4
          padding: 0
          +res('mob')
            margin-bottom: 30px
        li
          border-bottom: 1px solid #e4e4e4
          list-style: none
        p
          font-family: $text-font-book
          margin-bottom: 20px

      &_proposal
        text-align: center
        p
          font-family: $text-font-book

    .form-search__desc
      margin-bottom: 30px

</style>
